import React, { useEffect, useRef, useState } from 'react';
import { Button, ButtonGroup, Col, Container, Row, Table, Toast } from 'react-bootstrap';
import { State } from 'react-powerplug';
//import Dropdown from 'react-dropdown';
//import {getAiAnnotations, renderAIHighlights} from '../../API/ai';
import { setLVDocumentDB } from '../../Database/lvDocumentDAO';
import '../../Styles/Annotator/LVComponent.css';
//import {getTrackAIFromBackend} from '../../API/annotator';
import SuggestAnnotationComponent from './SuggestAnnotationComponent';
import HighlightComponent from './HighlightComponent';
import ShowHighlightsComponent from './ShowHighlightsComponent';
//import {getTrackAIFromBackend} from "../../API/annotator";
//import {saveAITracking} from "../../Database/AnnotationsDAO";
import { getAiAnnotations, renderAIHighlights } from '../../API/ai';
import { fetchData, getAnnotations, retrieveMatches, writeInitialData } from '../../API/annotatorApi';
import { updateProjectStatus } from '../../API/analysenrequestdata';
import { createUpdates, getCurrentStateOfLvDocument } from '../../Utils/helpers';
import {
    addPositionToAnnotationsTrainingAPI, addPositionToAnnotationsTrainingExclusionsAPI,
    addPositionToDatasetAPI,
    getKategoriesDataAPI,
    removePositionFromDatasetAPI,
    updateIndividualKategoriesDataAPI
} from '../../API/kategories';
import { getOut } from '../../Utils/Common';

import PositionPickerComponent from './PositionPickerComponent';
import QuestionAnsweringComponent from './QuestionAnsweringComponent';
import RenderAnswerComponent from './RenderAnswerComponent';
import { useHistory } from 'react-router-dom';
import { Copy, Eye, Layers, LogIn, LogOut, Scissors, Upload } from 'react-feather';
import { getMatchedPosition } from '../../API/parser';
import { Multiselect } from 'multiselect-react-dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Loader from 'react-loader-advanced';
import Oval from 'react-loader-spinner';

//import {getKategoriesDataAPI, updateIndividualKategoriesDataAPI} from "../../API/kategories";


async function selectCategory(o, parsedlv_id) {
    //let uid = localStorage.getItem('parsedlv_id')
    let categories_as_str = null;
    if (o.category != null) {
        categories_as_str = o.category.join(',');
    }
    if (parsedlv_id === "None") {
        parsedlv_id = o.row_id.split('=')[0]
    }
    let categoryData= {"row_id": o.row_id, "category": categories_as_str, "type": o.type, "lv_id": parsedlv_id};
    let result = await updateIndividualKategoriesDataAPI(categoryData);
    if (result.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
        getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
    }
}

async function addToDataset(o, parsedlv_id, auto = false) {
    if (o.category === null || o.category.length === 0) {
        if (!auto) {
            alert("Please select at least one category first")
        }
        return
    }
    if (!Array.isArray(o.category)) {
        o.category = o.category.split(',')
    }
    addPositionToDatasetAPI(o, parsedlv_id).then(async res => {
        if (!auto) {
            let res_json = await res.json();
            alert(res_json.message);
        }
    });
}

async function removeFromDataset(o, parsedlv_id) {
    removePositionFromDatasetAPI(o, parsedlv_id).then(async res => {
        let res_json = await res.json();
        alert(res_json.message);
    });
}

async function copyToClipboard(row_id) {
    await navigator.clipboard.writeText(row_id);
}

const lvTextStyle = {
    whiteSpace: 'pre-line',
    textAlign: 'left',
    height: 925
};

const Card = ({children}) => <div>{children}</div>;

function LVComponent(props) {
    let [parsedlv_id] = useState(props.lvList.parsedlv_id);

    const [lvList, setLvList] = useState(props.lvList);
    const [ozData, setOzData] = useState([]);
    const [annotations, setAnnotations] = useState([]);
    const [lvreportDisplay] = useState(props.lvreportDisplay);
    const [lvDocument, setDocument] = useState([]);
    const [currentRef, setCurrentRef] = useState([]);
    const [selectedPreference, setSelectedPreference] = useState([]);
    const [positionMatches, setPositionMatches] = useState([]);
    const [matchedAnnotationData, setMatchedAnnotationData] = useState([]);
    //const [filteredPositionMatches, setFilteredPositionMatches]
    const [positionRef, setPositionRef] = useState('');
    const [positionText, setPositionText] = useState('');
    let history = useHistory();
    // let location = useLocation();

    //Components Visibility
    const [suggestAnnotationComponentVisibility] = useState(props.suggestComponentShow);
    const [lvCustomerVisibility] = useState(props.lvCustomerView);
    const [positionPickerShow, setPositionPickerShow] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);

    // datatool related stuff
    const [lvStatus, setLvStatus] = useState(props.lvstatus);
    const [pageNumber, setPageNumber] = useState(0);
    const [pageItemOffset, setPageItemOffset] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isLastPage, setIsLastPage] = useState(false);
    const [jobID, setJobID] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [dataLength, setDataLength] = useState(props.data_length);
    const scrollableDivRef = useRef(null);

    const [show, setShow] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastTitle, setToastTitle] = useState("");

    const handleOpenQAModal = (o) => {

        setSelectedItems(o.category);
        setCurrentRef(o.row_id);

        console.log('Selected categories for row :', o.row_id);

        setShowModal(true);
    };

    const handleCloseQAModal = () => {
        setShowModal(false);
    };

    function addToAnnotationsTraining(row_id) {
        addPositionToAnnotationsTrainingAPI(row_id).then(async res => {
            let res_json = await res.json();
            if (res_json.status === 200) {
                setToastTitle("Successful");
                setToastMessage(res_json.response);
            } else {
                setToastTitle("Failed");
                setToastMessage(res_json.detail);
            }
            setShow(true);
        });
    }

    function addToAnnotationsExclusions(row_id) {
        addPositionToAnnotationsTrainingExclusionsAPI(row_id).then(async res => {
            let res_json = await res.json();
            if (res_json.status === 200) {
                setToastTitle("Successful");
                setToastMessage(res_json.response);
            } else {
                setToastTitle("Failed");
                setToastMessage(res_json.detail);
            }
            setShow(true);
        });
    }

    let renderAndTrackAI = async (lvList_data) => {

        if (props.lvstatus === 'open' && sessionStorage.getItem('Render') === '1') {
            let lvID = lvList_data.parsedlv_id;
            await getAiAnnotations(lvID);
            let positions = lvList_data?.OZ;
            positions = positions.filter((item) => item.type === 'Item' && item.hashRef !== false)
                .map((item) => ({
                    hashRef: item.hashRef,
                    rowId: item.row_id,
                    ord: item.ord,
                    short_text: item.short_text
                }));
            let matchedAnnotations = [];
            let matchedDocuments = [];
            for (let item of positions) {
                let response = await getAnnotations(item.hashRef);

                let filteredTarget = response.response;
                let filteredAnnotations = filteredTarget.annotations;
                let document = filteredTarget.lv_document;
                if (document) {
                    let pText = document.pText;
                    let target = createUpdates(filteredAnnotations, item, pText);
                    matchedAnnotations.push(...target.targetAnnotations);
                    matchedDocuments.push({ id: item.rowId, pText: target.targetLvDocument });
                }
            }

            renderAIHighlights(positions).then(async function(annotations) {
                let lv_document = await getCurrentStateOfLvDocument();
                let allAnnotations = [];
                // Converting the object to array object
                let items = Object.keys(annotations);
                items.forEach((val) => allAnnotations.push(...annotations[val]));
                // Create a new array to store the updated objects
                let mergedAnnotations = [...allAnnotations, ...matchedAnnotations];
                let mergedDocument = [...lv_document, ...matchedDocuments];
                // Saving the initial the initial ai data
                let resp = await writeInitialData(lvID, mergedAnnotations, mergedDocument);

                if (await resp === 202) {
                    await updateProjectStatus({ 'uploadlv_id': lvID, 'status': 'in-progress' });
                    localStorage.setItem('Render', JSON.stringify(0));

                    alert('Successfully stored the initial data');
                    history.push(process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE);


                } else {
                    alert('Initialdata write is unsuccessful, please finalize again.');
                }
            });

            //renderAIHighlights(lvID)
        }

    };


    // const handleCategoryChange = (index, category) => {
    //     let updated_lvList = {...props.lvList};
    //     updated_lvList.OZ[index].category = (category != null) ? category.join(',') : category;
    //     const newState = {...location.state, lvList: {data: updated_lvList}};
    //     history.replace({ ...location, state: newState});
    // };

    const handlePreviousPage = () => {
        if (lvStatus !== 'search') {
          return;
        }

        setOzData([]);

        if (pageNumber > 0) {
            setPageItemOffset((pageNumber - 1) * pageSize);
            setPageNumber((currPageNumber) => currPageNumber - 1);
            setIsLastPage(false);
        }
    };

    const handleNextPage =  () => {
        if (lvStatus !== 'search') {
          return;
        }

        setOzData([]);

        if (!isLastPage) {
            setPageItemOffset((pageNumber + 1) * pageSize);
            setPageNumber((currPageNumber) => currPageNumber + 1);
        }
    };

    const checkLastPage = () => {
        const totalPages = Math.ceil(dataLength / pageSize);
        setIsLastPage(pageNumber >= totalPages - 1);
    }

    useEffect(async () => {
        if (jobID === "") {
            return;
        }

        setIsLoading(true);

        const response_data = await fetchData(jobID, pageItemOffset, pageSize)

        checkLastPage();

        let newPageData = {
            title: "Search",
            projectName: "Search",
            laufzeit: "Heute",
            parsedlv_id: "None",
            OZ: response_data.map(item => item.OZ),
            annotations: {
                annotations: response_data.flatMap(item => item.annotations),
                lv_document: response_data.filter(item => item.lvDocument !== null && item.lvDocument !== undefined).map(item => item.lvDocument)
            }
        };

        setDataLength(response_data[0].data_length);
        props.setAnnotationData(newPageData.annotations)
        setLvList(newPageData);

        setIsLoading(false);
    }, [pageNumber, pageSize]);

    useEffect(async () => {

        let oldArray = await getKategoriesDataAPI();
        const newArray = oldArray.map(o => o.category).sort();
        const lvList_data = lvList;
        const annotationData = (props.lvstatus === "search") ? lvList.annotations: props.annotationData;
        let annots = annotationData?.annotations;

        checkLastPage();

        let document = annotationData?.lv_document;

        if (props.lvstatus === 'in-progress' || props.lvstatus === 'Completed') {
            setLVDocumentDB(JSON.stringify(document));
        }

        let ozdatas;

        //let positionCategories = await getKategoriesDataAPI().then((data) => data.data);

        await renderAndTrackAI(lvList_data);
        let OZ_data = lvList_data?.OZ;

        /// localStorage.setItem('parsedlv_id', lvList_data?.parsedlv_id);
        localStorage.setItem('projectName', lvList_data?.projectName);
        localStorage.setItem('title', lvList_data?.title);
        localStorage.setItem('laufzeit', lvList_data?.laufzeit);

        ozdatas = OZ_data?.map((o, index) => (

            <tr key={index}>
                <td>{o.ref}</td>
                <td>
                    {suggestAnnotationComponentVisibility && (
                        <>
                            <SuggestAnnotationComponent
                                positionID={o}
                                annotationData={annotationData}
                                setAnnotationData={props.setAnnotationData}
                                parsedlv_id={parsedlv_id} />
                            {
                                o.long_text != null && o.long_text !== "" ? (
                                    <>
                                        &emsp;
                                        <Button size="sm" id="add_to_training" className="handwai-btn-report"
                                                onClick={() => addToDataset(o, parsedlv_id)}>
                                            <Upload /> To cat. data</Button>&emsp;
                                        <Button size="sm" id="remove_from_training" className="handwai-btn-report"
                                                onClick={() => removeFromDataset(o, parsedlv_id)}>
                                            <Scissors /> From cat. data</Button>
                                        &emsp;
                                        <Button size="sm" id="add_to_ann_training" className="handwai-btn-green"
                                                onClick={() => addToAnnotationsTraining(o.row_id)}>
                                            <LogIn/> To ann. data</Button>
                                        &emsp;
                                        <Button size="sm" id="add_to_ann_exclusions" className="handwai-btn-green"
                                                onClick={() => addToAnnotationsExclusions(o.row_id)}>
                                            <LogOut /> From ann. data</Button>
                                        &emsp;
                                        <Button
                                            size="sm"
                                            variant="primary"
                                            className="handwai-btn-report"
                                            onClick={async () => {
                                                handleOpenQAModal(o);
                                                alert(o.long_text);
                                                setPositionText(o.long_text);
                                            }} // Pass rowId to handleOpenQAModal
                                        >
                                         <Eye />   View QA items
                                        </Button>
                                         &emsp;
                                        <Button
                                            size="sm"
                                            variant="primary"
                                            className="handwai-btn-report"
                                            onClick={() => copyToClipboard(o.row_id)}
                                        >
                                            <Copy />
                                        </Button>
                                         <br /> <br />
                                        {/* RenderAnswer  Component */}
                                        <RenderAnswerComponent
                                            position={o}
                                            categories={o.category !== undefined && o.category !== null
                                              ? Array.isArray(o.category)
                                                ? o.category
                                                : o.category.split(',')
                                              : []}
                                            //categories={['material', 'Farben']}
                                            adviceList={props.adviceList}
                                            lv_id={parsedlv_id}
                                            annotationData={annotationData}
                                            setAnnotationData={props.setAnnotationData}
                                        />&emsp;
                                        <br />
                                        <Multiselect
                                            placeholder={'Neue Kategorie erstellen'}
                                            isObject={false}
                                            options={newArray}
                                            onSelect={(selectedList, selectedItem) => {
                                                if (o.category == null) {
                                                    o.category = [];
                                                }
                                                if (!Array.isArray(o.category)) {
                                                    o.category = o.category.split(',');
                                                }
                                                o.category.push(selectedItem);
                                                selectCategory(o, parsedlv_id);
                                                // handleCategoryChange(index, o.category);
                                                addToDataset(o, parsedlv_id, true);
                                            }}
                                            onRemove={(selectedList, removeItem) => {
                                                if (!Array.isArray(o.category)) {
                                                    o.category = o.category.split(',');
                                                }
                                                o.category = o.category.filter(function(e) {
                                                    return e !== removeItem;
                                                });
                                                if (o.category.length === 0) {
                                                    o.category = null;
                                                }
                                                selectCategory(o, parsedlv_id);
                                                // handleCategoryChange(index, o.category);
                                                addToDataset(o, parsedlv_id, true);
                                            }}
                                            selectedValues={
                                                o.category != null ? o.category.split(',') : []
                                            }
                                            avoidHighlightFirstOption={true}
                                            selectionLimit={3}
                                            showCheckbox
                                        />

                                        <span onClick={async () => {
                                            let matches = await getMatchedPosition(o.ltext_hashvalue);
                                            matches = matches.data;
                                            let annotationData = await retrieveMatches(matches, o.ltext_hashvalue);
                                            annotationData = annotationData.response;
                                            setSelectedPreference(o.hashRef);
                                            setMatchedAnnotationData(annotationData);
                                            setPositionPickerShow(true);
                                            setPositionMatches(matches);
                                            setPositionRef(o.ltext_hashvalue);
                                            setCurrentRef(o.row_id);
                                        }}>
                            {(o.hashRef === false && o.matchCount >= 2) ? (
                                <Layers id={'M' + o.uid} color={'yellow'} />) : (o.hashRef) ? (
                                <Layers id={'M' + o.uid} color={'green'} />) : ('')}
                        </span>
                                    </>
                                ) : <br />}
                        </>
                    )}
                    <br />
                    {(o.hinweis !== 'nan' && o.hinweis !== '') && <h5>{o.hinweis}</h5>}
                    <State initial={{ value: [], tag: 'Default' }}>
                        {({ state }) => (
                            <Card>
                                <HighlightComponent
                                    parsedlv_id={parsedlv_id}
                                    state={state}
                                    ozDataUnit={o}
                                    highlightPossible={props.highlightPossible}
                                    annotationData={annotationData}
                                    setAnnotationData={props.setAnnotationData}
                                />
                            </Card>
                        )}
                    </State>
                </td>
                <td>{'menge' in o ? o.menge : '-'}</td>
                <td>{'unit' in o ? o.unit : '-'}
                </td>
                {lvreportDisplay&&<td>
                    <Button className={"handwai-btn-report"}
                disabled={(o.long_text==="nan" || o.long_text===undefined || o.long_text==="")}
            onClick={()=>
            {
                let baseURL = "https://www.google.com/search?q="
                //let lText = ""
                //if(o.long_text!=="nan" && o.long_text!==undefined){lText=o.long_text}
                window.open(baseURL + o.long_text, 'googletext')}
            }
            ><FontAwesomeIcon icon={faSearch}/> Suchen</Button>
                </td>}
            </tr>
        ));

        if (scrollableDivRef.current) {
            scrollableDivRef.current.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
        }

        setOzData(ozdatas);
        setAnnotations(annots);
        setDocument(document);
        setLvStatus(props.lvstatus);
        setJobID(props.jobID);
        setDataLength(props.data_length);
        setIsLoading(false);
    }, [lvList]);

    return (
        <div style={{ height: 925 }}>
            <div
                style={{
                    zIndex: 1050,
                    position: 'fixed',
                    top: '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                }}
            >
                <Toast
                    onClose={() => setShow(false)}
                    show={show}
                    delay={5000}
                    autohide
                >
                    <Toast.Header>
                        <strong className="mr-auto">{ toastTitle }</strong>
                    </Toast.Header>
                    <Toast.Body>{ toastMessage }</Toast.Body>
                </Toast>
            </div>
            <div className="handwai-dark div-border handwai-text-label-normal add-10-padding"
                 style={lvTextStyle}>
                <Row className="div-bottom-border addMarginMinus10">
                    <Col lg={5}>
                        {!lvCustomerVisibility ? <>
                                <label
                                    className="handwai-text-label-normal">Projekt: {localStorage.getItem("projectName")}</label>
                            </>
                            :
                            <>
                                <label
                                    className="handwai-text-label-normal">LV-Analyse: {localStorage.getItem("projectName")}</label>
                            </>
                        }
                    </Col>
                    <Col lg={5}>
                        {!lvCustomerVisibility && <>
                            <label
                                className="handwai-text-label-normal">GAEB-Name: {localStorage.getItem("title")}</label></>}
                    </Col>
                    <Col lg={'auto'}>
                        <label
                            className="handwai-text-label-normal">Laufzeit: {localStorage.getItem("laufzeit")}</label>
                    </Col>

                    <ShowHighlightsComponent lvreportDisplay={lvreportDisplay} annotations={annotations}
                                             lvDocument={lvDocument} lvstatus={props.lvstatus} />

                </Row>
                <br />
                <Loader
                    show={lvStatus === "search" && isLoading}
                    message={<span>
                        <Oval
                            visible={true}
                            height="80"
                            width="80"
                            color="#ffffff"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            type="Oval" /></span>}
                >
                    <Container fluid>
                        <div className="lv-div-scroll" ref={scrollableDivRef}
                             style={{ height: props.lvstatus === 'search' ? 800 : 860 }}>
                            <Table striped bordered hover variant="dark">
                                <thead>
                                <tr>
                                    <th>OZ.</th>
                                    <th>Leistungsbeschreibung</th>
                                    <th>Menge</th>
                                    <th>Einh.</th>
                                    {lvreportDisplay && <th>Tools</th>}
                                </tr>
                                </thead>
                                <tbody>{ozData}</tbody>
                            </Table>
                        </div>
                    </Container>
                </Loader>
                {props.lvstatus === 'search' && (
                    <div style={{ margin: '10px 0px 10px 15px', width: '100%' }}>
                        <ButtonGroup>
                            <Button onClick={handlePreviousPage} disabled={pageNumber === 0}
                                    style={{ margin: '0 5px 0 0' }}>Previous Page</Button>
                            <Button onClick={handleNextPage} disabled={isLastPage}>Next Page</Button>
                        </ButtonGroup>
                        <div style={{ float: 'right', margin: '0 28px 0 0' }}>
                            <label>
                                Results on page:&nbsp;
                                <select name="selectedFruit" value={pageSize}
                                        onChange={e => setPageSize(parseInt(e.target.value))}>
                                    <option value="10">10</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                </select>
                            </label>
                        </div>
                    </div>
                )}
            </div>
            <PositionPickerComponent
                positionMatches={positionMatches}
                matchedAnnotationData={matchedAnnotationData}
                positionRef={positionRef}
                currentRef={currentRef}
                annotationData={props.lvstatus === "search" ? lvList.annotations : props.annotationData}
                setAnnotationData={props.setAnnotationData}
                selectedPreference={selectedPreference}
                show={positionPickerShow}
                onHide={() => setPositionPickerShow(false)} />


            <QuestionAnsweringComponent currentRef={currentRef} categories={selectedItems} position={positionText}
                                        show={showModal} onHide={handleCloseQAModal} />
        </div>
    );
}

export default LVComponent;
